import { LiveUpdate } from '@capawesome/capacitor-live-update';
import { getPlatform } from 'utils/updateManagerRemote';

//用户视频列表类型
export enum VideoListType {
  Collect = 1,
  History = 2,
}

//接口数据缓冲时间
export const ApiCachedSeconds = 3000 * 24 * 3;

//加上一点随机, 防止集中过期
export const ApiCachedSecondsRandom = ApiCachedSeconds * (0.9 + Math.random() * 0.1);

// 节流防抖间隔（ms）
export const ThrottleTImeout = 3 * 1000;

// appflow 的更新规则
const AppVersion = '1.0'; // app大版号
const WebVersion = '0'; // web小版号
export const LocalVersion = AppVersion + ':' + WebVersion; // 当前版本
export const getAppVersion = (version?) => (version || LocalVersion).split(':')[0];
export const getWebVersion = (version?) => (version || LocalVersion).split(':')[1];

// 自托管 的更新规则
const localVersion = '1.0.0'; // 版本号通常遵循语义化版本规范（SemVer），格式为 主版本号.次版本号.修订号（例如 1.9.5）
const getLocalVersion = () => {
  return localVersion;
};
export const compareVersions = (version1, version2) => {
  // 将版本号拆分为数组
  const v1 = (version1 + '').split('.').map(Number);
  const v2 = (version2 + '').split('.').map(Number);

  // 补零，使两个版本号长度一致
  const maxLength = Math.max(v1.length, v2.length);
  while (v1.length < maxLength) v1.push(0);
  while (v2.length < maxLength) v2.push(0);

  // 逐段比较版本号
  for (let i = 0; i < maxLength; i++) {
    if (v1[i] > v2[i]) return 1; // version1 更新
    if (v1[i] < v2[i]) return -1; // version2 更新
  }

  return 0; // 版本号相同
};
// 比较本地版号，获取 当前版号
export const getRealVersion = async () => {
  let nowBundleId = getPlatform() != 'native' ? null : (await LiveUpdate.getCurrentBundle()).bundleId;
  if (nowBundleId && compareVersions(nowBundleId, localVersion) == 1) {
    return nowBundleId;
  }
  return localVersion;
};
// 比较云端版号， 知道 是否需要更新
export const checkNeedUpdate = async (lastVersion) => {
  const localVersion = getLocalVersion();
  const nowBundleId = (await LiveUpdate.getCurrentBundle()).bundleId;
  const realVersion = await getRealVersion();
  console.log('远程版号:', lastVersion);
  console.log('本地版号:', localVersion);
  console.log('当前版号:', nowBundleId);
  console.log('选取版号:', realVersion);

  const needUpdate = compareVersions(lastVersion, realVersion) == 1;
  // console.log('lastVersion', lastVersion);
  // console.log('realVersion', realVersion);
  // console.log('needUpdate', needUpdate);
  return needUpdate;
};
